import { render } from "./SearchCard.vue?vue&type=template&id=0b50fcb3&scoped=true"
import script from "./SearchCard.vue?vue&type=script&lang=js"
export * from "./SearchCard.vue?vue&type=script&lang=js"

import "./SearchCard.vue?vue&type=style&index=0&id=0b50fcb3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b50fcb3"]])

export default __exports__